export default __webpack_public_path__ + "static/media/kaus-carousel-3-thumbnail.07684dc7.jpg";